exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".date-tool{width:150px;height:20px}.date-tool .date{float:left;height:20px;display:inline-block;color:#acc3ff;font-size:12px;line-height:20px;text-indent:4px;text-align:right;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-5f9489b2!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/date-tool/index.vue
// module id = 174
// module chunks = 0